(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/form/assets/javascripts/components/control-group.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/form/assets/javascripts/components/control-group.trinidad.js');
"use strict";

(() => {
  "use strict";

  const __webpack_require__ = {};
  __webpack_require__.n = module => {
const getter = module && module.__esModule ? () => module['default'] : () => module;
    __webpack_require__.d(getter, {
      a: getter
    });
    return getter;
  };
  __webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
          enumerable: true,
          get: definition[key]
        });
      }
    }
  };
  __webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  let __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (control_group)
  });
  ; 
  const external_React_namespaceObject = window["React"];
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactIcon_namespaceObject = window["svs"]["ui"]["ReactIcon"];
  var external_svs_ui_ReactIcon_default = __webpack_require__.n(external_svs_ui_ReactIcon_namespaceObject);
  ; 

  const ControlGroup = props => {
    const classNames = ['control-group'];
    if (props.hasError) {
      classNames.push('error');
    }
    if (props.className) {
      classNames.push(props.className);
    }
    if (props.v2) {
      classNames.push('form-v2');
      if (props.isLessSpace) {
        classNames.push('input-control-less-space');
      }
    }
    const renderBottomInfo = () => {
      if (props.v2) {
        return React.createElement(external_React_namespaceObject.Fragment, null, props.helpMessage ? React.createElement("div", {
          className: "control-group-info-wrapper"
        }, React.createElement("div", {
          className: "help-message",
          id: "".concat(props.idForInput, "_desc")
        }, props.helpMessage)) : null, props.infoMessage ? React.createElement("div", {
          className: "control-group-info-wrapper info-message-wrapper"
        }, React.createElement("div", {
          className: "info-message",
          id: "".concat(props.idForInput, "_desc")
        }, props.infoMessage)) : null, React.createElement("div", {
          className: "control-group-error-wrapper"
        }, React.createElement("div", {
          className: "error-icon"
        }, React.createElement(external_svs_ui_ReactIcon_default(), {
          color: "fc-red",
          icon: "exclamation-sign",
          size: "200"
        })), React.createElement("div", {
          "aria-live": "assertive",
          className: "error-message",
          id: props.idForInputError ? "".concat(props.idForInputError, "_error") : null
        }, props.errorMessage)));
      }
      return React.createElement(external_React_namespaceObject.Fragment, null, React.createElement("div", {
        "aria-live": "assertive",
        className: "error-message",
        id: props.idForInputError ? "".concat(props.idForInputError, "_error") : null
      }, props.errorMessage), props.helpMessage ? React.createElement("div", {
        className: "help-message"
      }, props.helpMessage) : null, props.infoMessage ? React.createElement("div", {
        className: "info-message",
        id: "".concat(props.idForInput, "_desc")
      }, props.infoMessage) : null);
    };
    return React.createElement("div", {
      className: classNames.join(' ')
    }, props.children, renderBottomInfo());
  };
  ControlGroup.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "ControlGroup",
    "props": {
      "children": {
        "description": "",
        "type": {
          "name": "node"
        },
        "required": false
      },
      "className": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "hasError": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "helpMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "idForInput": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "idForInputError": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "infoMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isLessSpace": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "v2": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      }
    }
  };
  const control_group = ControlGroup;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactForm = window.svs.ui.ReactForm || {}).ControlGroup = __webpack_exports__["default"];
})();

 })(window);